class MobileSplitMenu extends HTMLElement {
  connectedCallback() {
    this.primaryItems = this.querySelectorAll('.mobile-split-menu__primary-item[data-primary-index]');
    this.panelTriggers = this.querySelectorAll('[data-panel-trigger]');
    this.panels = this.querySelectorAll('[data-panel]');
    this.panelEmpty = this.querySelector('[data-panel-empty]');
    this.closeButton = this.querySelector('[data-mobile-menu-close]');

    this.primaryItems.forEach((item) => {
      const toggle = item.querySelector('[data-primary-toggle]');
      if (!toggle) return;

      toggle.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
          this.togglePrimary(item);
        },
        true
      );
    });

    this.panelTriggers.forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
          this.activatePanel(btn.dataset.panelTrigger);
        },
        true
      );
    });

    this.querySelectorAll(
      'button:not([data-primary-toggle]):not([data-panel-trigger]):not([data-mobile-menu-close]):not([data-mobile-menu-language-toggle])'
    ).forEach((button) => {
      button.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
        },
        true
      );
    });

    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
          e.preventDefault();
          this.closeMenuDrawer();
        },
        true
      );
    }

    this.initLanguageSelector();

    this.querySelectorAll('a[href]:not(.disclosure__link)').forEach((link) => {
      link.addEventListener('click', () => this.closeMenuDrawer());
    });

    this.updatePanelVisibility();
  }

  initLanguageSelector() {
    const languageBtn = this.querySelector('[data-mobile-menu-language-toggle]');
    if (!languageBtn) return;

    const formRoot = languageBtn.closest('localization-form');
    const panel = formRoot?.querySelector('ul');
    const localeInput = formRoot?.querySelector('input[name="locale_code"]');
    if (!panel) return;

    languageBtn.addEventListener(
      'click',
      (e) => {
        e.stopImmediatePropagation();
        const isExpanded = languageBtn.getAttribute('aria-expanded') === 'true';
        panel.toggleAttribute('hidden', isExpanded);
        languageBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      },
      true
    );

    formRoot.querySelectorAll('a.disclosure__link[data-value]').forEach((link) => {
      link.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (localeInput) localeInput.value = link.dataset.value;
          formRoot.querySelector('form')?.submit();
        },
        true
      );
    });
  }

  closeMenuDrawer() {
    const headerDrawer = document.querySelector('header-drawer');
    const openDetails = headerDrawer?.querySelector('details[open]');
    const summary = openDetails?.querySelector('summary');

    if (!openDetails) return;

    openDetails.classList.remove('menu-opening');
    summary?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-tablet');

    openDetails.removeAttribute('open');
  }

  togglePrimary(item) {
    const isExpanded = item.classList.contains('is-expanded');
    const toggle = item.querySelector('[data-primary-toggle]');

    this.primaryItems.forEach((el) => {
      el.classList.remove('is-expanded');
      const btn = el.querySelector('[data-primary-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });

    if (!isExpanded) {
      item.classList.add('is-expanded');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      const directPanel = item.dataset.directPanel;
      if (directPanel) {
        this.activatePanel(directPanel);
        return;
      }

      const activeTrigger =
        item.querySelector('[data-panel-trigger].is-active') ||
        item.querySelector('[data-panel-trigger]');

      if (activeTrigger) {
        this.activatePanel(activeTrigger.dataset.panelTrigger);
      }
    } else {
      this.clearPanels();
    }
  }

  activatePanel(panelId) {
    if (!panelId) return;

    this.panelTriggers.forEach((trigger) => {
      const isMatch = trigger.dataset.panelTrigger === panelId;
      trigger.classList.toggle('is-active', isMatch);
      trigger.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isMatch = panel.dataset.panel === panelId;
      panel.classList.toggle('is-active', isMatch);
      panel.hidden = !isMatch;
    });

    if (this.panelEmpty) this.panelEmpty.hidden = true;

    this.updatePanelVisibility();
  }

  clearPanels() {
    this.panelTriggers.forEach((trigger) => {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    if (this.panelEmpty) this.panelEmpty.hidden = false;

    this.updatePanelVisibility();
  }

  updatePanelVisibility() {
    const hasActivePanel = this.querySelector('[data-panel].is-active:not([hidden])');
    if (this.panelEmpty) {
      this.panelEmpty.hidden = !!hasActivePanel;
    }
  }
}

customElements.define('mobile-split-menu', MobileSplitMenu);
